import { Component } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { TaskWorkflowByProfile } from "../core/model/task-workflow-by-profile";
import { TaskWorkflowByProfileService } from "../core/service/task-workflow-by-profile.service";

@Component({
  selector: "app-task",
  templateUrl: "./task.component.html",
  styleUrls: ["./task.component.scss"],
})
export class TaskComponent {
  tasks: TaskWorkflowByProfile[];

  constructor(
    private _router: Router,
    private _taskWorkflowByProfileService: TaskWorkflowByProfileService
  ) {}

  ngOnInit() {
    this.getTasks();
  }

  getTasks() {
    this._taskWorkflowByProfileService.getListTaskWorkflowByProfile().subscribe(
      (data) => {
        this.tasks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    this._router.navigate(["parametrage/task/add-task"]);
  }

  edit(taskId): void {
    this._router.navigate(["parametrage/task/edit-task/" + taskId]);
  }

  affectation(taskId): void {
    this._router.navigate(["parametrage/affectation/" + taskId]);
  }

  checklist(taskId): void {
    this._router.navigate(["parametrage/task-document/" + taskId]);
  }
}
